import { Chart } from "react-chartjs-2";

type BarLineChartType = {
    labels: string[];
    deliveryDataset:number[]
    openDataset: number[]
}

const options = {
    scales: {
        y: {
            type: 'linear' as const,
            display: true,
            position: 'left' as const,
            min: 0,
            max: 100,
            title: {
                display: true,
                text: 'Delivery Rate (%)',
            },
        },
        y1: {
            type: 'linear' as const,
            display: true,
            position: 'right' as const,
            min: 0,
            max: 100,
            grid: {
                drawOnChartArea: false,
            },
            title: {
                display: true,
                text: 'Open Rate (%)',
            },
        },
    },
};

const BarLineChart = (props: BarLineChartType) => {
    const {labels, openDataset, deliveryDataset} = props

    const data = {
        labels,
        datasets: [
            {
                type: 'line' as const,
                label: 'Open Rate',
                borderColor: '#13294B',
                borderWidth: 2,
                fill: false,
                data: openDataset,
                yAxisID: 'y1',
            },
            {
                type: 'bar' as const,
                label: 'Delivery Rate',
                backgroundColor: '#7BAFD4',
                data: deliveryDataset,
                borderColor: 'white',
                borderWidth: 2,
                yAxisID: 'y',
            }
        ],
    };

    return (
        <Chart type='bar' data={data} options={options} />
    )
}

export default BarLineChart